/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Frame_RateInputs */



/**
* | output |
* | --- |
* | "Frame Rate" |
*
* @param {Options_General_Frame_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_frame_rate = /** @type {((inputs?: Options_General_Frame_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Frame_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fréquence d'images")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bildrate")
	if (locale === "it") return /** @type {LocalizedString} */ ("Frequenza dei fotogrammi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Частота кадров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Velocidad de fotogramas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("帧率")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレームレート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ्रेम रेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Taxa de quadros")
	return /** @type {LocalizedString} */ ("Frame Rate")
});